<template>
  <div class="flex items-center gap-2.5 py-1">
    <span :class="dotClass" class="shrink-0 w-5 h-5 rounded-full flex items-center justify-center">
      <Icon :name="icon" :size="12" :strokeWidth="2.2" />
    </span>
    <div class="flex-1 min-w-0 text-xs text-ink-800 font-medium truncate">{{ title }}</div>
    <span class="text-2xs font-semibold" :class="impactClass">{{ impact }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '../ui/Icon.vue';

const props = defineProps({
  icon:     { type: String, required: true },
  title:    { type: String, required: true },
  impact:   { type: String, required: true },
  severity: { type: String, default: 'good' }, // good | warn | danger
});

const dotClass = computed(() => ({
  good:   'bg-accent-50 text-accent-600',
  warn:   'bg-warn-50 text-warn-700',
  danger: 'bg-danger-50 text-danger-600',
}[props.severity]));

const impactClass = computed(() => ({
  good:   'text-accent-700',
  warn:   'text-warn-700',
  danger: 'text-danger-700',
}[props.severity]));
</script>
